import { alpha, type Components, type Theme } from '@mui/material/styles';
import { fontFamilyMono } from '../typography';

export function baselineOverrides(theme: Theme): Components<Theme> {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*, *::before, *::after': { boxSizing: 'border-box' },
        html: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          overflowX: 'hidden',
        },
        body: {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          overflowX: 'hidden',
          fontVariantNumeric: 'tabular-nums',
          '@media (prefers-reduced-motion: reduce)': {
            '*': {
              animationDuration: '0.01ms !important',
              transitionDuration: '0.01ms !important',
            },
          },
        },
        ':focus-visible': {
          outline: 'none',
          boxShadow: theme.customShadows.focus,
        },
        '::selection': { backgroundColor: alpha(theme.palette.primary.main, 0.28) },
        '#root': { minHeight: '100vh' },
        'code, kbd, samp, .mono': { fontFamily: fontFamilyMono },
        '*::-webkit-scrollbar': { width: 8, height: 8 },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.divider,
          borderRadius: 4,
        },
        '*::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
      },
    },
  };
}
